import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromFieldTeamDetailState from './field-team-detail.reducer';
import { FieldTeamDetailEffects } from './field-team-detail.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromFieldTeamDetailState.fieldTeamDetailFeatureKey,
			fromFieldTeamDetailState.reducer
		),
		EffectsModule.forFeature([FieldTeamDetailEffects]),
	],
})
export class FieldTeamDetailStateModule {}
